"use client";

import React, { memo } from "react";
import { Breadcrumb } from "@chakra-ui/react";

export type WithBreadcrumbProps = {
  children: React.ReactNode;
};

function WithBreadcrumbInner({ children }: WithBreadcrumbProps) {
  return (
    <Breadcrumb.Root>
      <Breadcrumb.List gap="2">{children}</Breadcrumb.List>
    </Breadcrumb.Root>
  );
}

// Prevent re-renders when props are identical
const WithBreadcrumb = memo(WithBreadcrumbInner);

export default WithBreadcrumb;
